<!-- ═══════════════════════════════════════════════════════════
     INVESTMENT PROPERTY — new shell layout (CalculatorType 1)
     ═══════════════════════════════════════════════════════════ -->
<ng-container *ngIf="calculatorType === '1'; else cgLayout">
  <app-ip-shell [activeStep]="1">

    <!-- ── FORM COLUMN ── -->
    <div formCol>
      <div class="ip-form-head">
        <div class="ip-form-head__step-meta">Step 01 &middot; Location &amp; Buyer</div>
        <h1 class="ip-form-head__title">Where and who's buying?</h1>
        <p class="ip-form-head__subtitle">
          Enter any UK postcode or select any city to explore investment potential
        </p>
      </div>

      <div class="ip-form-body">

        <!-- Location field -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="pincode">Investment location</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>UK only &middot; postcode or city</span>
          </div>
          <div class="ip-input ip-search-input">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              id="pincode"
              class="ip-input__field"
              placeholder="e.g. M1 4BT, Manchester city centre"
              [(ngModel)]="Pincode"
              (input)="geoLocation()">
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)"  type="button">London</button>
            <button class="ip-chip" [class.is-active]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)" type="button">Liverpool</button>
            <button class="ip-chip" [class.is-active]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)" type="button">Manchester</button>
            <button class="ip-chip" [class.is-active]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)" type="button">Birmingham</button>
          </div>
        </div>

        <!-- Buyer status (shown once a city is selected) -->
        <div class="ip-field" *ngIf="City">
          <div class="ip-field__head">
            <label class="ip-field__label">Residency</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Determines SDLT surcharge</span>
          </div>
          <div class="ip-buyer-cards">
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'" type="button">
              <span class="ip-buyer-card__title">UK Resident</span>
              <span class="ip-buyer-card__sub">UK Tax Resident</span>
              <span class="ip-buyer-card__sdlt-note">Standard SDLT rates apply</span>
            </button>
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer==='1'" (click)="foreignbuyer='1'" type="button">
              <span class="ip-buyer-card__title">Foreign Buyer</span>
              <span class="ip-buyer-card__sub">Non-UK resident. Includes most NRI / diaspora investors.</span>
              <span class="ip-buyer-card__sdlt-note">Foreign buyer SDLT Surcharge applicable.</span>
            </button>
          </div>
        </div>

        <!-- Purchase type (shown once a city is selected) -->
        <div class="ip-field" *ngIf="City">
          <div class="ip-field__head">
            <label class="ip-field__label">Purchase type</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Determines SDLT rate band</span>
          </div>
          <div class="ip-buyer-cards">
            <button class="ip-buyer-card" [class.is-active]="buyerType==='ftb'" (click)="buyerType='ftb'" type="button">
              <span class="ip-buyer-card__title">First Time Buyer</span>
              <span class="ip-buyer-card__sub">You are buying your first property anywhere in the world.</span>
              <span class="ip-buyer-card__sdlt-note">0% up to £300k · FTB relief</span>
            </button>
            <button class="ip-buyer-card" [class.is-active]="buyerType==='investment'" (click)="buyerType='investment'" type="button">
              <span class="ip-buyer-card__title">Investment / 2nd Property</span>
              <span class="ip-buyer-card__sub">Buying an additional residential property.</span>
              <span class="ip-buyer-card__sdlt-note">Additional dwelling SDLT Surcharge Applicable.</span>
            </button>
          </div>
        </div>

      </div><!-- /ip-form-body -->

      <div class="ip-form-actions">
        <span></span>
        <div style="display:flex;gap:12px;align-items:center">
          <button class="ip-btn ip-btn--outline" type="button" *ngIf="skipbtnvisibility" (click)="next('skip')">Skip</button>
          <button class="ip-btn ip-btn--primary" type="button" (click)="next('next')">
            Continue
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div><!-- /formCol -->

    <!-- ── RAIL ── -->
    <div rail>
      <div class="ip-rail-marketing">
        <div class="ip-rail-marketing__eyebrow">Investment Property</div>
        <p class="ip-rail-marketing__lede">
          As a property investor, calculate 3-dimensional returns in tandem from rent, foreign exchange gains and capital growth on your property in UK. Play with your assumptions and optimise investment strategies.
        </p>
        <div class="ip-rail-marketing__divider-label">UK BTL</div>
        <div class="ip-rail-stats">
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Avg. yield</span>
            <span class="ip-rail-stat__value">
              {{ City === 'Manchester' ? '6.5' : City === 'Liverpool' ? '7.2' : City === 'Birmingham' ? '5.8' : '5.5' }}<sup>%</sup>
            </span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">5-yr growth</span>
            <span class="ip-rail-stat__value">
              +{{ City === 'Manchester' ? '25' : City === 'Liverpool' ? '18' : City === 'Birmingham' ? '20' : '15' }}<sup>%</sup>
            </span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">BoE base rate</span>
            <span class="ip-rail-stat__value">3.75<sup>%</sup></span>
          </div>
        </div>
      </div>
    </div><!-- /rail -->

  </app-ip-shell>
</ng-container>

<!-- ═══════════════════════════════════════════════════════════
     CAPITAL GROWTH — new shell layout (CalculatorType 2)
     ═══════════════════════════════════════════════════════════ -->
<ng-template #cgLayout>
<ng-container *ngIf="calculatorType === '2'; else sdltLayout">
  <app-ip-shell
    [activeStep]="1"
    [steps]="cgSteps"
    calculatorName="Capital Growth Calculator">

    <!-- ── FORM COLUMN ── -->
    <div formCol>
      <div class="ip-form-head">
        <div class="ip-form-head__step-meta">Location &amp; Buyer</div>
        <h1 class="ip-form-head__title">Where's the property?</h1>
        <p class="ip-form-head__subtitle">
          Enter any UK postcode or select any city to explore investment potential
        </p>
      </div>

      <div class="ip-form-body">

        <!-- Location field -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="pincode_cg">Investment location</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>UK only &middot; postcode or city</span>
          </div>
          <div class="ip-input ip-search-input">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              id="pincode_cg"
              class="ip-input__field"
              placeholder="e.g. M1 4BT, Manchester city centre"
              [(ngModel)]="Pincode"
              (input)="geoLocation()">
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)"  type="button">London</button>
            <button class="ip-chip" [class.is-active]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)" type="button">Liverpool</button>
            <button class="ip-chip" [class.is-active]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)" type="button">Manchester</button>
            <button class="ip-chip" [class.is-active]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)" type="button">Birmingham</button>
          </div>
        </div>

        <!-- Buyer status (shown once a city is selected) -->
        <div class="ip-field" *ngIf="City">
          <div class="ip-field__head">
            <label class="ip-field__label">Buyer status</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Affects FX return calculation</span>
          </div>
          <div class="ip-buyer-cards">
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'" type="button">
              <span class="ip-buyer-card__title">UK Resident</span>
              <span class="ip-buyer-card__sub">Returns shown in GBP only.</span>
              <span class="ip-buyer-card__sdlt-note">No FX conversion needed</span>
            </button>
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer==='1'" (click)="foreignbuyer='1'" type="button">
              <span class="ip-buyer-card__title">Foreign Buyer</span>
              <span class="ip-buyer-card__sub">Returns shown in GBP + home currency.</span>
              <span class="ip-buyer-card__sdlt-note">FX appreciation included</span>
            </button>
          </div>
        </div>

      </div><!-- /ip-form-body -->

      <div class="ip-form-actions">
        <span></span>
        <div style="display:flex;gap:12px;align-items:center">
          <button class="ip-btn ip-btn--outline" type="button" *ngIf="skipbtnvisibility" (click)="next('skip')">Skip</button>
          <button class="ip-btn ip-btn--primary" type="button" (click)="next('next')">
            Continue
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div><!-- /formCol -->

    <!-- ── RAIL ── -->
    <div rail>
      <div class="ip-rail-marketing">
        <div class="ip-rail-marketing__eyebrow">Capital Growth</div>
        <h2 class="ip-rail-marketing__title">Project your property's <em>long-term value</em>.</h2>
        <p class="ip-rail-marketing__lede">
          Model UK property capital appreciation over 5, 10 or 15 years — with or without FX gains for overseas investors.
        </p>
        <div class="ip-rail-marketing__divider-label">UK Capital Growth &middot; 2026</div>
        <div class="ip-rail-stats">
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">10-yr avg growth</span>
            <span class="ip-rail-stat__value">4.8<sup>%</sup></span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">5-yr growth</span>
            <span class="ip-rail-stat__value">
              +{{ City === 'Manchester' ? '28' : City === 'Liverpool' ? '18' : City === 'Birmingham' ? '20' : '15' }}<sup>%</sup>
            </span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Avg. yield</span>
            <span class="ip-rail-stat__value">
              {{ City === 'Manchester' ? '6.8' : City === 'Liverpool' ? '7.2' : City === 'Birmingham' ? '5.8' : '5.5' }}<sup>%</sup>
            </span>
          </div>
        </div>
      </div>
    </div><!-- /rail -->

  </app-ip-shell>
</ng-container>
</ng-template>

<!-- ═══════════════════════════════════════════════════════════
     STAMP DUTY — new shell layout (CalculatorType 5)
     ═══════════════════════════════════════════════════════════ -->
<ng-template #sdltLayout>
<ng-container *ngIf="calculatorType === '5'; else pfxLayout">
  <app-ip-shell
    [activeStep]="1"
    [showStepper]="false"
    calculatorName="Stamp Duty Calculator">

    <!-- ── FORM COLUMN ── -->
    <div formCol>
      <div class="ip-form-head">
        <div class="ip-form-head__step-meta">Stamp Duty Calculator</div>
        <h1 class="ip-form-head__title">Where's the property?</h1>
        <p class="ip-form-head__subtitle">
          Enter any UK postcode or select any city to explore investment potential
        </p>
      </div>

      <div class="ip-form-body">

        <!-- Location field -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="pincode_sdlt">Investment location</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>UK only &middot; postcode or city</span>
          </div>
          <div class="ip-input ip-search-input">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              id="pincode_sdlt"
              class="ip-input__field"
              placeholder="e.g. M1 4BT, Manchester city centre"
              [(ngModel)]="Pincode"
              (input)="geoLocation()">
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)"  type="button">London</button>
            <button class="ip-chip" [class.is-active]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)" type="button">Liverpool</button>
            <button class="ip-chip" [class.is-active]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)" type="button">Manchester</button>
            <button class="ip-chip" [class.is-active]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)" type="button">Birmingham</button>
          </div>
        </div>

        <!-- Buyer status -->
        <div class="ip-field" *ngIf="City">
          <div class="ip-field__head">
            <label class="ip-field__label">Buyer status</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Affects SDLT surcharge</span>
          </div>
          <div class="ip-buyer-cards">
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'" type="button">
              <span class="ip-buyer-card__title">UK Resident</span>
              <span class="ip-buyer-card__sub">UK Tax Resident</span>
              <span class="ip-buyer-card__sdlt-note">Standard SDLT rates apply</span>
            </button>
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer==='1'" (click)="foreignbuyer='1'" type="button">
              <span class="ip-buyer-card__title">Foreign Buyer</span>
              <span class="ip-buyer-card__sub">Non-UK resident purchasing UK property.</span>
              <span class="ip-buyer-card__sdlt-note">Foreign buyer SDLT Surcharge applicable.</span>
            </button>
          </div>
        </div>

      </div><!-- /ip-form-body -->

      <div class="ip-form-actions">
        <span></span>
        <div style="display:flex;gap:12px;align-items:center">
          <button class="ip-btn ip-btn--outline" type="button" *ngIf="skipbtnvisibility" (click)="next('skip')">Skip</button>
          <button class="ip-btn ip-btn--primary" type="button" (click)="next('next')">
            Continue
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div><!-- /formCol -->

    <!-- ── RAIL ── -->
    <div rail>
      <div class="ip-rail-marketing">
        <div class="ip-rail-marketing__eyebrow">Stamp Duty (SDLT)</div>
        <h2 class="ip-rail-marketing__title">Know your <em>exact tax liability</em> before you buy.</h2>
        <p class="ip-rail-marketing__lede">
          SDLT varies by property price, purchase type, and buyer residency. Get an accurate breakdown in seconds.
        </p>
        <div class="ip-rail-marketing__divider-label">UK SDLT &middot; 2026</div>
        <div class="ip-rail-stats">
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Primary home (£400k)</span>
            <span class="ip-rail-stat__value">£7.5k</span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Investment (£400k)</span>
            <span class="ip-rail-stat__value">£27.5k</span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Foreign surcharge</span>
            <span class="ip-rail-stat__value">+2%</span>
          </div>
        </div>
      </div>
    </div><!-- /rail -->

  </app-ip-shell>
</ng-container>
</ng-template>

<!-- ═══════════════════════════════════════════════════════════
     PREDICTIVE FOREIGN EXCHANGE — new shell layout (CalculatorType 4)
     ═══════════════════════════════════════════════════════════ -->
<ng-template #pfxLayout>
<ng-container *ngIf="calculatorType === '4'; else ewrLayout">
  <app-ip-shell
    [activeStep]="1"
    [showStepper]="false"
    calculatorName="Predictive Foreign Exchange">

    <div formCol>
      <div class="ip-form-head">
        <div class="ip-form-head__step-meta">Predictive Foreign Exchange</div>
        <h1 class="ip-form-head__title">Where's the property?</h1>
        <p class="ip-form-head__subtitle">
          Enter any UK postcode or select any city to explore investment potential
        </p>
      </div>

      <div class="ip-form-body">
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="pincode_pfx">Investment location</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>UK only &middot; postcode or city</span>
          </div>
          <div class="ip-input ip-search-input">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input type="text" id="pincode_pfx" class="ip-input__field" placeholder="e.g. M1 4BT, Manchester city centre" [(ngModel)]="Pincode" (input)="geoLocation()">
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)"  type="button">London</button>
            <button class="ip-chip" [class.is-active]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)" type="button">Liverpool</button>
            <button class="ip-chip" [class.is-active]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)" type="button">Manchester</button>
            <button class="ip-chip" [class.is-active]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)" type="button">Birmingham</button>
          </div>
        </div>
      </div>

      <div class="ip-form-actions">
        <span></span>
        <div style="display:flex;gap:12px;align-items:center">
          <button class="ip-btn ip-btn--outline" type="button" *ngIf="skipbtnvisibility" (click)="next('skip')">Skip</button>
          <button class="ip-btn ip-btn--primary" type="button" (click)="next('next')">
            Continue
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div rail>
      <div class="ip-rail-marketing">
        <div class="ip-rail-marketing__eyebrow">Predictive FX</div>
        <h2 class="ip-rail-marketing__title">See how <em>currency gains</em> amplify your returns.</h2>
        <p class="ip-rail-marketing__lede">
          GBP has historically appreciated against many emerging-market currencies — giving overseas investors a hidden return on top of capital growth.
        </p>
        <div class="ip-rail-marketing__divider-label">GBP FX &middot; 2026</div>
        <div class="ip-rail-stats">
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">GBP/INR 10-yr avg</span>
            <span class="ip-rail-stat__value">+3.2<sup>%</sup></span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">GBP/AED 10-yr avg</span>
            <span class="ip-rail-stat__value">+1.8<sup>%</sup></span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">GBP/USD 10-yr avg</span>
            <span class="ip-rail-stat__value">+1.4<sup>%</sup></span>
          </div>
        </div>
      </div>
    </div>

  </app-ip-shell>
</ng-container>
</ng-template>

<!-- ═══════════════════════════════════════════════════════════
     ESTIMATED WEEKLY RENT — new shell layout (CalculatorType 3)
     ═══════════════════════════════════════════════════════════ -->
<ng-template #ewrLayout>
<ng-container *ngIf="calculatorType === '3'; else legacyLayout">
  <app-ip-shell
    [activeStep]="1"
    [steps]="ewrSteps"
    calculatorName="Estimated Weekly Rent">

    <div formCol>
      <div class="ip-form-head">
        <div class="ip-form-head__step-meta">Estimated Weekly Rent</div>
        <h1 class="ip-form-head__title">Where's the property?</h1>
        <p class="ip-form-head__subtitle">
          Enter any UK postcode or select any city to explore investment potential
        </p>
      </div>

      <div class="ip-form-body">
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="pincode_ewr">Investment location</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>UK only &middot; postcode or city</span>
          </div>
          <div class="ip-input ip-search-input">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input type="text" id="pincode_ewr" class="ip-input__field" placeholder="e.g. M1 4BT, Manchester city centre" [(ngModel)]="Pincode" (input)="geoLocation()">
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)"  type="button">London</button>
            <button class="ip-chip" [class.is-active]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)" type="button">Liverpool</button>
            <button class="ip-chip" [class.is-active]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)" type="button">Manchester</button>
            <button class="ip-chip" [class.is-active]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)" type="button">Birmingham</button>
          </div>
        </div>

        <div class="ip-field" *ngIf="City">
          <div class="ip-field__head">
            <label class="ip-field__label">Buyer status</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Affects FX return display</span>
          </div>
          <div class="ip-buyer-cards">
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'" type="button">
              <span class="ip-buyer-card__title">UK Resident</span>
              <span class="ip-buyer-card__sub">Returns shown in GBP only.</span>
            </button>
            <button class="ip-buyer-card" [class.is-active]="foreignbuyer==='1'" (click)="foreignbuyer='1'" type="button">
              <span class="ip-buyer-card__title">Foreign Buyer</span>
              <span class="ip-buyer-card__sub">Returns shown in GBP + home currency.</span>
            </button>
          </div>
        </div>
      </div>

      <div class="ip-form-actions">
        <span></span>
        <div style="display:flex;gap:12px;align-items:center">
          <button class="ip-btn ip-btn--outline" type="button" *ngIf="skipbtnvisibility" (click)="next('skip')">Skip</button>
          <button class="ip-btn ip-btn--primary" type="button" (click)="next('next')">
            Continue
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div rail>
      <div class="ip-rail-marketing">
        <div class="ip-rail-marketing__eyebrow">Weekly Rent Calculator</div>
        <h2 class="ip-rail-marketing__title">Know your <em>rental income</em> before you commit.</h2>
        <p class="ip-rail-marketing__lede">
          Model weekly, monthly, and annual rental income from yield or a known rent figure — in GBP and your home currency.
        </p>
        <div class="ip-rail-marketing__divider-label">{{ City || 'UK' }} Rental Market &middot; 2026</div>
        <div class="ip-rail-stats">
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Avg. yield</span>
            <span class="ip-rail-stat__value">{{ City === 'Liverpool' ? '7.2' : City === 'Manchester' ? '6.8' : City === 'Birmingham' ? '5.8' : '5.5' }}<sup>%</sup></span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">Avg. weekly rent</span>
            <span class="ip-rail-stat__value">{{ City === 'London' ? '£650' : City === 'Manchester' ? '£320' : City === 'Liverpool' ? '£280' : '£300' }}</span>
          </div>
          <div class="ip-rail-stat">
            <span class="ip-rail-stat__label">5-yr growth</span>
            <span class="ip-rail-stat__value">+{{ City === 'Manchester' ? '28' : City === 'Liverpool' ? '18' : City === 'Birmingham' ? '20' : '15' }}<sup>%</sup></span>
          </div>
        </div>
      </div>
    </div>

  </app-ip-shell>
</ng-container>
</ng-template>

<!-- ═══════════════════════════════════════════════════════════
     LEGACY LAYOUT — all other calculator types
     ═══════════════════════════════════════════════════════════ -->
<ng-template #legacyLayout>
<div class="property-select-page">

  <!-- LEFT PANEL -->
  <div class="panel-left">
    <div class="panel-left-bg"></div>
    <div class="panel-left-content">

      <!-- Logo -->
      <div class="panel-logo">
        <a routerLink="/"><img src="assets/adventum-logo.svg" alt="Adventum Calculators" class="panel-logo-img"></a>
      </div>

      <!-- Hero card -->
      <div class="panel-hero-card">
        <h3 class="panel-hero-title">Invest in {{City || 'UK'}}'s Future</h3>
        <p class="panel-hero-sub">{{HeaderContent || "The UK's fastest-growing property markets with strong yields and capital appreciation."}}</p>
        <div class="panel-stats">
          <div class="panel-stat">
            <div class="panel-stat-val">{{City === 'Manchester' ? '6.5%' : City === 'Liverpool' ? '7.2%' : City === 'Birmingham' ? '5.8%' : '5.5%'}}</div>
            <div class="panel-stat-lbl">Avg. Yield</div>
          </div>
          <div class="panel-stat">
            <div class="panel-stat-val">{{City === 'Manchester' ? '+23%' : City === 'Liverpool' ? '+18%' : City === 'Birmingham' ? '+20%' : '+15%'}}</div>
            <div class="panel-stat-lbl">5yr Growth</div>
          </div>
          <div class="panel-stat">
            <div class="panel-stat-val">{{City === 'Manchester' ? '#1' : City === 'Liverpool' ? '#2' : City === 'Birmingham' ? '#3' : 'UK'}}</div>
            <div class="panel-stat-lbl">UK BTL City</div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- RIGHT PANEL -->
  <div class="panel-right">
    <div class="panel-right-inner">

      <!-- Top bar -->
      <div class="panel-topbar">
        <div class="location-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          {{City || 'United Kingdom'}}
        </div>
      </div>

      <!-- Heading -->
      <h2 class="section-title">Where would you like to invest?</h2>
      <p class="section-sub">Enter any UK postcode or select any city to explore investment potential</p>

      <!-- Search input -->
      <div class="search-wrap">
        <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
        <input
          class="search-input"
          type="text"
          id="pincode"
          placeholder="Search postcode or city..."
          [(ngModel)]="Pincode"
          (input)="geoLocation()">
      </div>

      <!-- Popular area chips -->
      <p class="popular-label">Popular areas:</p>
      <div class="area-chips">
        <button class="area-chip" [class.selected]="City==='London'"     (click)="selectCity('London','SW1A 1AA',51.5074,-0.1278)">London</button>
        <button class="area-chip" [class.selected]="City==='Liverpool'"  (click)="selectCity('Liverpool','L1 1AA',53.4084,-2.9916)">Liverpool</button>
        <button class="area-chip" [class.selected]="City==='Manchester'" (click)="selectCity('Manchester','M1 1AA',53.4808,-2.2426)">Manchester</button>
        <button class="area-chip" [class.selected]="City==='Birmingham'" (click)="selectCity('Birmingham','B1 1AA',52.4862,-1.8904)">Birmingham</button>
      </div>

      <!-- Buyer Status card (shown when city selected) -->
      <div class="buyer-card" *ngIf="City">
        <div class="buyer-card-title">Buyer Status</div>
        <div class="buyer-card-sub">This affects your stamp duty calculation</div>
        <div class="buyer-row">
          <div class="buyer-row-labels">
            <div class="buyer-row-label-main">Are You a Foreign (Non-UK Resident) Buyer?</div>
            <div class="buyer-row-label-sub">Foreign buyers pay an additional 2% stamp duty surcharge</div>
          </div>
          <div class="toggle-pair">
            <button class="toggle-opt" [class.active]="foreignbuyer!=='1'" (click)="foreignbuyer='0'">UK Resident</button>
            <button class="toggle-opt" [class.active]="foreignbuyer==='1'" (click)="foreignbuyer='1'">Foreign Buyer</button>
          </div>
        </div>
      </div>

      <!-- Nav buttons -->
      <div class="panel-nav">
        <button class="btn-back-outline" *ngIf="skipbtnvisibility" (click)="next('skip')">
          Skip
        </button>
        <button
          class="btn-continue"
          [class.btn-continue--active]="City!=''"
          (click)="next('next')">
          Continue
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
        </button>
      </div>

    </div>
  </div>

</div>
</ng-template>
